module.exports = __webpack_public_path__ + "static/media/teacher-class.021429ee.png";